import axios from "axios";

const getRepoErrorMessage = (error) => {
  const d = error?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (d && typeof d.message === "string") return d.message;
  return null;
};

export const getRepoEventById = async (id) => {
  try {
    const req = await axios.get(
      `https://repositorio-api.aden.org/api/v2/repo_aden/events/${id}`,
    );
    return req.data;
  } catch (error) {
    throw new Error(error);
  }
};

export const postRepoAttendedRegister = async (eventId, body) => {
  try {
    const req = await axios.post(
      `https://repositorio-api.aden.org/api/v2/repo_aden/events/${eventId}/registrations/public`,
      body,
    );
    return req.data.response_data;
  } catch (error) {
    const msg = getRepoErrorMessage(error);
    if (msg) throw new Error(msg);
    throw error;
  }
};

export const patchRepoAttended = async (eventId, body) => {
  const headers = {
    "Content-Type": "application/json",
  };
  try {
    const req = await axios.patch(
      `https://repositorio-api.aden.org/api/v2/repo_aden/events/${eventId}/registrations/public`,
      body,
      { headers: headers },
    );
    return req.data;
  } catch (error) {
    const msg = getRepoErrorMessage(error);
    if (msg) throw new Error(msg);
    throw error;
  }
};

export const postRepoCreateBadge = async (cycleId, body) => {
  try {
    await axios.post(
      `https://repositorio-api.aden.org/api/v2/repo_aden/events/cycles/${cycleId}/badges/public`,
      body,
    );
  } catch (error) {
    throw new Error(JSON.stringify(error.response.data.detail.data));
  }
};

export const getRepoBadge = async (cycleId, email) => {
  try {
    const response = await axios.get(
      `https://repositorio-api.aden.org/api/v2/repo_aden/badges/cycle/${cycleId}?email=${email}`,
    );
    return response.data;
  } catch (error) {
    throw new Error(JSON.stringify(error.response.data.detail.data));
  }
};

export const getRepoSurveyPublic = async (eventId, email) => {
  const req = await axios.get(
    `https://repositorio-api.aden.org/api/v2/repo_aden/surveys/event/${eventId}/public`,
    { params: { partner_email: email } },
  );
  return req.data;
};
